import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import growInstance from "../../../../../public/images/growInstance.svg";
import { useHistory } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CreateContentItemDialog } from "../../../../shell/components/CreateContentItemDialog";
export const EmptyState = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [openCreateContentDialog, setOpenCreateContentDialog] = useState(false);
  return <>
      <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap={4} sx={{
      px: 2,
      mb: 2
    }} data-sentry-element="Box" data-sentry-source-file="EmptyState.tsx">
        <Box width="386px" data-sentry-element="Box" data-sentry-source-file="EmptyState.tsx">
          <Typography variant="h4" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
            {t("dashboard.emptyStateTitle")}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
          mt: 1.5
        }} data-sentry-element="Typography" data-sentry-source-file="EmptyState.tsx">
            {t("dashboard.emptyStateDescription")}
          </Typography>
          <Box display="flex" gap={2} mt={3} data-sentry-element="Box" data-sentry-source-file="EmptyState.tsx">
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => setOpenCreateContentDialog(true)} data-sentry-element="Button" data-sentry-source-file="EmptyState.tsx">
              {t("common.content")}
            </Button>
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => history.push("/schema?triggerCreate=true")} data-sentry-element="Button" data-sentry-source-file="EmptyState.tsx">
              {t("common.model")}
            </Button>
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => history.push("/code?triggerCreate=true")} data-sentry-element="Button" data-sentry-source-file="EmptyState.tsx">
              {t("common.codeFile")}
            </Button>
          </Box>
        </Box>
        <Box data-sentry-element="Box" data-sentry-source-file="EmptyState.tsx">
          <img src={growInstance} />
        </Box>
      </Box>
      {openCreateContentDialog ? <CreateContentItemDialog open={openCreateContentDialog} onClose={() => setOpenCreateContentDialog(false)} /> : null}
    </>;
};